export const TRACKING_CAPTAINS_LIST = "SUPPLIERS_PORTAL_TRACKING_CAPTAINS_LIST";
export const TRACKING_CAPTAIN_SHOW = "SUPPLIERS_PORTAL_TRACKING_CAPTAIN_SHOW";
